export function formatNumber(n: string) {
    return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatStrFloat(value: string): string {
    const floatChar = value.indexOf(',') >= 0 ? ',' : value.indexOf('.') >= 0 ? '.' : null;

    if (floatChar === null) {
        return formatNumber(value);
    }

    let decimalPos = value.indexOf(floatChar);
    let leftSide = value.substring(0, decimalPos);
    let rightSide = value.substring(decimalPos);

    leftSide = formatNumber(leftSide);
    rightSide = formatNumber(rightSide);
    rightSide = rightSide.substring(0, 2);

    return `${leftSide},${rightSide}`;
}